import {
    CreateOrderPayload,
    CreateOrderResponse,
    DeleteOrderPayload,
    DeleteOrderResponse,
    ecsApi,
    GetOrdersResponse,
    UpdateOrderPayload,
    UpdateOrderResponse
} from '@services';

export const ordersApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getOrders: builder.mutation<GetOrdersResponse, void>({
            query: () => ({
                url: '/orders',
                method: 'GET'
            })
        }),
        createOrder: builder.mutation<CreateOrderResponse, CreateOrderPayload>({
            query: (payload) => ({
                url: '/orders',
                method: 'POST',
                body: payload
            })
        }),
        updateOrder: builder.mutation<UpdateOrderResponse, UpdateOrderPayload>({
            query: (payload) => ({
                url: '/orders',
                method: 'PUT',
                body: payload
            })
        }),
        deleteOrder: builder.mutation<DeleteOrderResponse, DeleteOrderPayload>({
            query: (payload) => ({
                url: '/orders',
                method: 'DELETE',
                body: payload
            })
        })
    })
});

export const { useGetOrdersMutation, useCreateOrderMutation, useUpdateOrderMutation, useDeleteOrderMutation } = ordersApi;
